import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-question-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './question-card.html'
})
export class QuestionCardComponent {
  @Input() question: string = '';
  @Input() icon: string = 'fas fa-question';
  @Input() disabled: boolean = false;
  @Output() cardClick = new EventEmitter<string>();

  onCardClick(): void {
    if (!this.disabled) {
      this.cardClick.emit(this.question);
    }
  }
}
